import { AfterViewChecked, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MsalService } from '@azure/msal-angular';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

import { MasterConstant } from '@app/constant/master.constant';
import { CommonHelper } from '@app/shared/helpers/common.helper';
import { ITableAttributes } from '@app/interface/table.interface';
import { TableConstant } from '@app/constant/table.constant';
import { ProfileService } from '@app/services/common/profile.service';
import { SharedService } from '@app/services/shared.service';
import { ProblemService } from '@app/services/failure/problem.service';
import { ApploadService } from '@app/services/appload.service';
import { GlobalSearch } from '@app/models/failure/problem.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RBACModel } from '@app/models/rbac/rbac.model';
import { environment } from '@env/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewChecked {

  @ViewChild('dialogsearch') dialogsearch: TemplateRef<any>;
  dlRefsearch: MatDialogRef<any>;

  menuOpened = new Subject<boolean>();
  isReadUser: boolean = false;
  profilename: string = '';
  imgProfile: any = 'assets/images/avatar.png';
  isImgProfile: boolean = false;
  headerChange: boolean = false;
  showform: boolean = true;
  showDropDown: boolean = false;
  showSearch: boolean = false;
  scrollValue: number = 0;
  breadcrumbObj: any;
  globalSearch: string = '';
  resultAttributes: ITableAttributes;
  resultHeader = TableConstant.FAILUREDASHBOARD_COLUMNS;
  onHvrTitleDesc = TableConstant.onHoverTitleDesc;
  resultDashboardBody: any = [];
  ifcId: number = 0;
  filterByOptions = MasterConstant.GlobalSearchFilter;
  searchTypes = ['Failure'];
  fieldTypes = ['Failure No', 'Failure DESC', 'Place', 'ELR', 'Suffix', 'Discipline', 'Delivery Unit'];

  tableSearch: FormGroup = this.fb.group({ problemId: [''] });
  get problemIdvalue() { return this.tableSearch.get('problemId'); }

  Search: FormGroup = this.fb.group({
    searchType: [''],
    globalSearch: [''],
    fieldSearch: ['']
  });
  get searchTypesValue() { return this.Search.get('searchType'); }
  get globalSearchValue() { return this.Search.get('globalSearch'); }
  get fieldSearchValue() { return this.Search.get('fieldSearch'); }

  // Resolve Identity
  private apiWorkUrl = `${environment.apiUrl_RBAC}`;
  private msalToken = sessionStorage.getItem('msal.idtoken');
  private modelRbacAccess: RBACModel;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private cmHelper: CommonHelper,
    private msalService: MsalService,
    private sharedService: SharedService,
    private profileService: ProfileService,
    private problemService: ProblemService,
    public apploadService: ApploadService,
    public httpClient: HttpClient) { }

  ngOnInit(): void {
    this.resolveIdentity();
    let interval = setInterval(() => {
      let loggedInUser = JSON.parse(sessionStorage.getItem('profile'));
      if (loggedInUser) {
        this.profilename = loggedInUser.givenName + ' ' + loggedInUser.surname;
        clearInterval(interval);
        this.getProfilePicture();
      }
    }, 1000); 
    this.sharedService.getScrollingValue().subscribe((value: number) => { this.scrollValue = value; });
    this.sharedService.getglobalSearchPopOpenValue().subscribe((value: boolean) => { 
      this.showSearch = value; 
      if(this.cmHelper.isNullOrUndefined(this.sharedService.getGlobalSearchEntityData())){
        let result = this.sharedService.getGlobalSearchEntityData();
        this.searchTypesValue.setValue(result.recordType);
        this.globalSearchValue.setValue(result.fieldValue);
        this.fieldSearchValue.setValue(result.fieldName);
      }
    });
  }

  ngAfterViewChecked(): void {
    this.isReadUser = (sessionStorage.getItem('myim') === 'MYIM_READONLY');
    this.headerChange = this.cmHelper.changeHeaderHeightURL(this.router.url);
  }

  resolveIdentity(){
    let interval = setInterval(() => {
      this.profileService.getProfile().subscribe(((x: any) => {
        sessionStorage.setItem('profile', JSON.stringify(x));
        clearInterval(interval);
        this.apploadService.initApploadService();
        this.service_getIdentityManagement(x.id, x.givenName);
      }));
    }, 1000);
  }

  service_getIdentityManagement(accountId: string, accountName: string) {
    const objPartSearch = {
      'messageContext': {
        'messageId': '8471E138-3066-0941-ECC5-701485076EC2',
        'sourceApplicationType': 'MYIM',
        'sourceType': 'Application'
      },
      'partySearchParameters': {
        'partyName': accountName,
        'partyEmail': null,
        'requestingAccountId': accountId
      }
    }
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': 'aa0bde47cde24f21948b7b649823e59d', // fetch from env file
      'Authorization': 'Bearer ' + this.msalToken,
      'user-token': '',
    });

    this.httpClient.post<any>(this.apiWorkUrl + '/entSharedServices/v1/organisations/partySearches', objPartSearch, { headers }).subscribe((x) => {
      let partyObj = x.party.length === 1
          ? x.party[0]
          : x.party.filter(a => a.account.accountId.toUpperCase() === accountId.toUpperCase())[0];

        this.httpClient.get<RBACModel>(this.apiWorkUrl + '/entSharedServices/v1/identities/identitiesManagement?accountId=' + accountId + '&partyId=' + partyObj.partyId, { headers }).subscribe((partyData) => {
          this.modelRbacAccess = partyData;
          sessionStorage.setItem('brole', partyData.party[0].businessRole.map(({ orgName }) => orgName?.toUpperCase()).toString());
          this.sharedService.setRbacAccess(this.modelRbacAccess);
        })
    })
  }

  getProfilePicture(): void {
    this.profileService.getProfileImage(sessionStorage.getItem('msal.idtoken'))
      .subscribe(x => { this.createImageFromBlob(x); });
  }

  createImageFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      this.imgProfile = reader.result;
      return this.imgProfile;
    }, false);
    if (image) {
      reader.readAsDataURL(image);
    }
  }

  dismissSidebar(): void {
    this.showDropDown = false;
    this.menuOpened.next(false);
  }

  hideDropDown(event: any, outsideClick = false): void {
    this.menuOpened.next(false);
    if (event) { event.stopPropagation(); }
    if (outsideClick && this.showDropDown) {
      this.showDropDown = false;
    } else if (!outsideClick) {
      this.showDropDown = !this.showDropDown;
    }
  }

  onAlert(): void {
    this.showDropDown = false;
    this.router.navigateByUrl('user/ualert');
  }

  onSignout(): void {
    localStorage.removeItem('token_name');
    this.msalService.logout();
    sessionStorage.clear();
    localStorage.clear();
  }

  onSearch(): void {
    this.sharedService.setGlobalSearchValue(this.globalSearch)
  }
  onSearchPanel(): void {
    this.showSearch = !this.showSearch;
    this.showform = !this.showform;
    this.tableSearch.reset();
    this.resultDashboardBody = [];
    this.Search.reset();
    this.searchTypesValue.setValue(this.searchTypes[0]);
    this.fieldSearchValue.setValue(this.fieldTypes[0]);
    if (!this.showSearch) { this.globalSearch = ''; }
  }
  AdvancedSearch(): void {
    this.showSearch = !this.showSearch;
    this.router.navigateByUrl('user/advancedsearch');
  }
  CloseSearchBar(): void {
    this.showSearch = false;
    this.showform = !this.showform;
    this.tableSearch.reset();
    this.resultDashboardBody = [];
    this.Search.reset();
  }
  quickSearch(): void {
    this.resultDashboardBody = [];
    let tempData = [];
    let globalSearchEntity = new GlobalSearch();
    globalSearchEntity.fieldName = this.fieldSearchValue.value;
    globalSearchEntity.fieldValue = this.globalSearchValue.value;
    globalSearchEntity.recordType = this.searchTypesValue.value;

    if(!this.cmHelper.isNullOrUndefined(this.sharedService.getGlobalSearchEntityData())){
      this.sharedService.setGlobalSearchEntityData(globalSearchEntity);
    }else{
      this.sharedService.setGlobalSearchEntityData(null);
      this.sharedService.setGlobalSearchEntityData(globalSearchEntity);
    }
    
    this.problemService.getProblemGobalSearch(globalSearchEntity)
      .subscribe((x: any) => {
        x.forEach(e => {
          tempData.push({
            Cat: { 'Value': e.color, 'IsHyperlink': false, 'image': this.fetchCategoryIcon(e), 'title': e.color + this.onHvrTitleDesc.Cat[e.color] },
            Priority: { 'Value': e.priority, 'IsHyperlink': false, 'IsPosition': true, 'title': e.priority + this.onHvrTitleDesc.Priority[e.priority] },
            FailureCode: { 'Value': e.problemCode, 'problemId': e.problemId, 'IsHyperlink': true, RedirectionLink: `${window.location.origin}/failure/fmanagement/${e.problemId}`, openInNewTab: true },
            FailureDate: { 'Value': e.problemDate ? this.cmHelper.getformattedDateTime(e.problemDate, null, true, true) : '', 'IsHyperlink': false },
            Place: { 'Value': e.placeName, 'IsHyperlink': false },
            EquipmentDesc: { 'Value': this.cmHelper.showDots(e.itemName, 25), 'IsHyperlink': false, 'title': e.itemName },
            FailureDetails: { 'Value': this.cmHelper.showDots(e.reportDetails, 25), 'IsHyperlink': false, 'title': e.reportDetails },
            TrustId: { 'Value': (e.delayId === 'Yes' ? 'Y' : 'N'), 'IsHyperlink': false, 'IsPosition': true, 'title': e.trustDetails },
            Risk: { 'Value': e.riskCode, 'IsHyperlink': false, 'IsPosition': true, 'title': e.riskCode + this.onHvrTitleDesc.Risk[e.riskCode] },
            Status: { 'Value': e.subStatus?.toUpperCase(), 'IsHyperlink': false },
          });
        });

        this.sharedService.setGlobalSearchResult(tempData);
        this.CloseSearchBar();
        this.router.navigateByUrl('search');
      });
  }
  fetchCategoryIcon(e: any) {
    return e.color === 'Pink' || e.color === 'Green' ? e.color + e.priority : e.color;
  }
  
}
